// @core/api/endpoints/workflow/list_registered_products.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListRegisteredProductsResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List registered products
 * Returns all products that have synced their manifests. Shows product_slug, version, and counts of registered events/node types/templates.
 */
export async function ListRegisteredProducts(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListRegisteredProductsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/product-registry`;
  const requestOptions = options;
  return client.get<ListRegisteredProductsResponse>(requestPath, { ...requestOptions, params });
}
